export default __webpack_public_path__ + "static/media/humidity.cd3c00a3.svg";